<div class="withdraw-crypto-container" (click)="addressBookOpened = false">
  <!-- STEP 1 - COMPLETE TRANSFER DATA FORM -->
  <div class="inner-container scroll" *ngIf="dataS.withdrawStep === 2">
    <div class="header">
      <img
        class="back-button"
        (click)="dataS.withdrawStep = 0"
        src="assets/icons/news/back-arrow.svg"
        alt="back button"
      />
      <div class="title-container">
        <h3>Retirar Crypto</h3>
        <p>Seleccioná tipo de moneda e ingresá una dirección</p>
      </div>
    </div>

    <div class="reminder">
      <app-reminder-message
      message="No se admiten retiros a BingX y FixedFloat."
       type="error"
     > 
      </app-reminder-message>
    </div>


    <div class="form-container">
      <mat-form-field class="select-crypto" appearance="outline">
        <mat-select
          [formControl]="cryptoSelected"
          class="crypto-ticker"
          (valueChange)="!blockchainSelected && blockchainSelected.setValue('')"
        >
          <mat-select-trigger style="display: flex; align-items: center; gap: 0.5em">
            <img
              class="option-img"
              [src]="'assets/icons/crypto/' + cryptoSelected.value.toLowerCase() + '.svg'"
              width="24"
              height="24"
              alt="icon"
            />
            <span class="option-description">
              {{ cryptoSelected.value }} -
              {{ cryptoService.getCoinFullName(cryptoSelected.value) }}
              <span *ngIf="cryptoSelected.value === 'USDC'"> (Nativo) </span>
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let coin of availableCoins" [value]="coin">
            <img
              class="option-img"
              [src]="'assets/icons/crypto/' + coin.toLowerCase() + '.svg'"
              width="24"
              height="24"
              alt="icon"
            />
            {{ coin }}
            <span class="option-description">
              - {{ cryptoService.getCoinFullName(coin) }}
              <span *ngIf="coin === 'USDC'">(Nativo)</span></span
            >
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="network-section" *ngIf="cryptoWithdrawType === 0 && !internalWithdraw">
        <div class="title-section">
          <h3 class="subtitle">Red de transferencia</h3>
          <p *ngIf="!loadingGetCost && costToShow">Costos válidos por {{ countDownSecond }}s</p>
        </div>
        <mat-form-field class="select-crypto" appearance="outline">
          <mat-select
            [formControl]="blockchainSelected"
            class="crypto-ticker"
            placeholder="Elegí la red de transferencia"
          >
            <mat-select-trigger style="display: flex; align-items: center; gap: 0.5em">
              <img
                class="option-img"
                [src]="
                  'assets/icons/news/' + blockchainSelected.value.toLowerCase() + '-network.svg'
                "
                width="24"
                height="24"
                alt="icon"
              />
              <span>
                {{ blockchainSelected.value }}
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let blockchain of blockchainsByCoin()" [value]="blockchain">
              <img
                class="option-img"
                [src]="'assets/icons/news/' + blockchain?.toLowerCase() + '-network.svg'"
                width="24"
                height="24"
                alt="icon"
              />
              {{ blockchainsNames(blockchain) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-error
          for="blockchainSelected"
          class="form-error"
          *ngIf="!blockchainSelected.pristine && blockchainSelected.invalid"
        >
          {{ getErrorMessage('blockchainSelected') }}</mat-error
        >
      </div>

      <div class="input-section">
        <h3 class="subtitle">Dirección de retiro</h3>
        <div class="form-container">
          <mat-form-field class="crypto-addresses-input" appearance="outline">
            <input type="text" matInput [formControl]="address" *ngIf="!addressBookOpened" />

            <mat-select
              #addressSelect
              [formControl]="address"
              *ngIf="addressBookOpened"
              (click)="$event.stopPropagation()"
              (openedChange)="addressSelectOpened($event)"
            >
              <mat-option value="">Seleccione una dirección de retiro</mat-option>
              <mat-option
                *ngFor="let cryptoAccount of getAccountsByNetwork()"
                [value]="cryptoAccount.address"
                (click)="addressBookOpened = false"
              >
                <img
                  class="option-img"
                  [src]="
                    'assets/icons/news/' + getNameByChain(cryptoAccount.chain) + '-network.svg'
                  "
                  width="24"
                  height="24"
                  alt="icon"
                />
                {{ cryptoAccount.description }} - {{ cryptoAccount.address.substring(0, 7) }}...{{
                  cryptoAccount.address.substring(cryptoAccount.address.length - 7)
                }}
              </mat-option>
            </mat-select>

            <mat-icon matSuffix>
              <img
                src="assets/icons/address_book.svg"
                class="img-icon"
                alt="icon"
                (click)="
                  this.addressBookOpened = !this.addressBookOpened;
                  $event.stopPropagation();
                  openAddressSelector()
                "
              />
            </mat-icon>
          </mat-form-field>
          <mat-error for="address" class="form-error" *ngIf="!address.pristine && address.invalid">
            {{ getErrorMessage('address') }}</mat-error
          >
        </div>
      </div>
      <div
        class="transfer-network-alert"
        [ngClass]="blockchainSelected.value === 'BSC' ? 'show' : 'hide'"
      >
        <p>
          Asegurate que la dirección de retiro sea o bien una billetera de Binance o que la misma
          soporta dicha red.
        </p>
        <img src="/assets/icons/warning-green.svg" alt="warning" />
      </div>

      <div
        class="transfer-network-alert"
        [ngClass]="
          blockchainSelected.value === 'TERRA' || blockchainSelected.value === 'TERRA2'
            ? 'show'
            : 'hide'
        "
      >
        <p>
          ¡Atención! No realizar retiros de la red TERRA a destinos que requieran la utilización de
          un MEMO (Binance, por ejemplo)
        </p>
        <img src="/assets/icons/warning-green.svg" alt="warning" />
      </div>

      <div class="input-section">
        <h3 class="subtitle">Cantidad a retirar</h3>
        <div class="form-container">
          <mat-form-field appearance="outline">
            <input
              type="text"
              matInput
              [formControl]="quantity"
              [mask]="
                cryptoService.isStableCoin(cryptoSelected.value) ? 'separator.3' : 'separator.5'
              "
              thousandSeparator="."
            />
            <mat-icon matSuffix (click)="setMaxAmount()">
              <span class="max-btn">
                <img src="/assets/icons/to_top.svg" alt="" />
              </span>
            </mat-icon>
          </mat-form-field>
        </div>
        <p class="available">
          Disponible:
          <strong>
            {{ +getAvailableAmount() | formatCoinAmount : cryptoSelected.value }}
            {{ cryptoSelected.value }}</strong
          >
        </p>
      </div>

      <div class="divider"></div>

      <div class="output-section">
        <label *ngIf="isChargeAddress || !internalWithdraw">{{
          isChargeAddress ? 'El comercio recibirá:' : 'Costo de la operación:'
        }}</label>
        <p *ngIf="(isChargeAddress || !internalWithdraw) && !loadingGetCost" class="fee-amount">
          {{
            cryptoService.isStableCoin(cryptoSelected.value)
              ? (getFinalFee() | number : '.0-3')
              : (getFinalFee() | number : '.0-5')
          }}
          {{ cryptoSelected.value }}
        </p>
        <div *ngIf="loadingGetCost">
          <div class="loading">
            <div class="circle-loader">
              <div class="checkmark draw"></div>
            </div>
          </div>
        </div>
        <label *ngIf="isChargeAddress">Pagarás:</label>
        <!-- <label *ngIf="!isChargeAddress && internalWithdraw">El otro usuario recibirá:</label> -->
        <label *ngIf="!isChargeAddress && !internalWithdraw">Recibirás:</label>
        <p class="transfer-amount" *ngIf="!internalWithdraw">
          {{
            cryptoService.isStableCoin(cryptoSelected.value)
              ? (getFinalWithdraw() | number : '.0-3')
              : (getFinalWithdraw() | number : '.0-5')
          }}
          {{ cryptoSelected.value }}
        </p>
      </div>

      <button
        class="td-btn primary"
        [disabled]="!isValidWithdraw() || blockTransferBtn || showErrorText"
        (click)="confirmBtnClicked()"
      >
        Transferir
      </button>

      <div class="error-txt" *ngIf="showErrorText">
        <p>{{ showErrorText }}</p>
      </div>
    </div>
  </div>

  <!-- STEP 2 - VERIFICATION -->
  <div class="inner-container" *ngIf="dataS.withdrawStep === 3">
    <img
      class="back-button"
      (click)="backToStepTwo()"
      src="assets/icons/news/back-arrow.svg"
      alt="back button"
    />

    <div class="title-container mobile">
      <h3>Verificación de seguridad</h3>
      <p class="color-text">Confirmá los montos ingresados y realizá una verificación</p>
    </div>

    <div class="verification-container">
      <div class="confirm-section">
        <div class="contain">
          <h3 class="subtitle">Vas a retirar:</h3>
          <div>
            <p class="info">
              {{ getFinalWithdraw() | number : '.2-8' }} {{ cryptoSelected.value }} &nbsp;
              <img
                [src]="'/assets/icons/crypto/' + cryptoSelected.value.toLowerCase() + '.svg'"
                alt="crypto_logo"
              />
            </p>
            <div *ngIf="loadingGetCost">
              <div class="loading">
                <div class="circle-loader">
                  <div class="checkmark draw"></div>
                </div>
              </div>
            </div>
            <span class="cost" *ngIf="!loadingGetCost"
              >Costo: {{ finalCost | number : '.2-2' }} U$D</span
            >
          </div>
        </div>
        <div class="contain">
          <h3 class="subtitle">A la dirección:</h3>
          <div class="coin">
            <p class="network">{{ blockchainSelected.value }}</p>
            <p class="info address">{{ getFormattedAddress(address.value) }}</p>
          </div>
        </div>
      </div>
      <app-static-second-factor
        [withdrawCrypto]="true"
        [isProcessingTransaction]="isProcessingTransaction"
        [invalidCode]="invalidCode"
        [textCode]="
          !twoFAStatus
            ? 'Introduce el codigo de 6 dígitos enviado a ' +
              getFormattedEmail(authService.loggedUser.email)
            : 'Introduce el codigo de autenticación 2FA'
        "
        (sendBtnClicked)="sendBtnClicked()"
        (valueCode)="fillCode($event)"
      >
        <!-- Se ocultó el botón, es necesario agregar un timer, cambiar condicional a !twoFAStatus -->
        <div class="resend" *ngIf="false">
          <p class="resend-btn" (click)="resend()">Reenviar código</p>
        </div>
      </app-static-second-factor>
    </div>
  </div>

  <!-- STEP 3 - CONFIRM -->
  <div class="inner-container" *ngIf="dataS.withdrawStep === 4">
    <div class="request-container">
      <img src="/assets/icons/confirm.svg" alt="success_logo" />

      <p class="info-title">¡{{ isChargeAddress ? 'Pago' : 'Retiro' }} exitoso!</p>

      <div class="transfer-info">
        <div class="contain">
          <h3 class="subtitle">{{ isChargeAddress ? 'Enviaste' : 'Retiraste' }}</h3>
          <p class="recieve-coin">
            {{ +withdrawRequest?.amount | formatCoinAmount : cryptoSelected.value }}
            {{ withdrawRequest?.coin }}
          </p>
        </div>
        <div class="contain">
          <h3 class="subtitle">A la dirección:</h3>
          <p class="address">{{ getFormattedAddress(address.value) }}</p>
        </div>
      </div>

      <div class="history-btn btn-background" (click)="historyBtnClicked()">
        <img src="assets/icons/link-white.svg" alt="link" /> Ver transacción
      </div>
      <div class="history-btn btn-margin" (click)="addAcount()" *ngIf="!accountExist">
        <img src="assets/icons/address_book_2.svg" alt="save_adress" />
        Guardar dirección
      </div>
    </div>
  </div>
</div>
